import { useEffect, useState, Fragment } from "react";
import Input from "../../Components/Input/Input";
import DropdownSearch from "../../Components/Input/Dropdown-Search";
import { getCall, postFormDataCall } from "../../services/apiCall";
import { getLocalToken } from "../../services/token";
import {
  convertDateOrder,
  decryptor,
  getPayloadHash,
} from "../../services/helper";
import { IoMdClose } from "react-icons/io";
import FileInput from "../../Components/Input/File-Input";
import PopupWrapper from "../../Components/PopUp/PopupWrapper";
import SkeletonProfile from "../../Components/Loader/Skeleton/ProfileSkeleton";

const CompanyProfile = () => {
  const genderOption = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const [serviceOption, setServiceOption] = useState([]);
  const [pincodeOption, setPincodeOption] = useState([]);

  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    dob: "",
    gender: "",
    service: "",
    pincode: "",
    city: "",
    profileImage: "",
    aadharFile: "",
    panFile: "",

    gst: "",
    company_email: "",
    bank_name: "",
    account_number: "",
    ifsc_code: "",
    branch_name: "",
  });

  const [profileImage, setProfileImage] = useState(null);
  const [aadhar, setAadhar] = useState(null);
  const [pan, setPan] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const imageHandler = (e) => {
    let uploadedFile = e.target.files;
    if (uploadedFile.length > 0) uploadedFile = uploadedFile[0];
    setData((prev) => ({ ...prev, profileImage: "" }));
    setProfileImage(uploadedFile);
  };

  const aadharHandler = (e) => {
    let uploadedFile = e.target.files;
    if (uploadedFile.length > 0) uploadedFile = uploadedFile[0];
    setData((prev) => ({ ...prev, aadharFile: "" }));
    setAadhar(uploadedFile);
  };

  const panHandler = (e) => {
    let uploadedFile = e.target.files;
    if (uploadedFile.length > 0) uploadedFile = uploadedFile[0];
    setData((prev) => ({ ...prev, panFile: "" }));
    setPan(uploadedFile);
  };

  const getCurrentGender = async (gender = "") => {
    if (!gender) return "";
    let filteredGender = genderOption.filter((e) => e?.value === gender);
    if (filteredGender.length > 0) {
      return filteredGender[0];
    }
    return "";
  };

  const getCurrentPincode = async (pincode = null) => {
    let pincodes = await getPincodes();

    if (!pincode) return null;
    if (!pincode) return "";
    let filteredPncode = pincodes.filter(
      (e) => String(e?.id) === String(pincode?.id)
    );
    if (filteredPncode.length > 0) {
      return filteredPncode[0];
    }
    return "";
  };

  const getCurrentService = async (service = null) => {
    let services = await getServices();

    if (!services) return null;
    if (!services) return "";
    let filteredService = services.filter(
      (e) => String(e?.id) === String(service?.id)
    );
    if (filteredService.length > 0) {
      return filteredService[0];
    }
    return "";
  };

  const updateProfile = async () => {
    const token = getLocalToken();
    let userInfo = decryptor({ encryptedData: token });
    if (!userInfo) return null;

    userInfo = JSON.parse(userInfo);

    const payload = {
      user_id: userInfo?.user_id,
      name: data?.name,
      email: data?.email,
      address: "",
      date_of_birth: data?.dob,
      gender: data?.gender ? data.gender?.value : "",
      pincode: data?.pincode ? data.pincode?.id : "",
      service: data?.service ? data.service?.id : "",

      gst: data?.gst || "",
      company_email: data?.company_email || "",
      bank_name: data?.bank_name || "",
      account_number: data?.account_number || "",
      ifsc_code: data?.ifsc_code || "",
      branch_name: data?.branch_name || "",
    };

    const dataToSend = { data: getPayloadHash({ data: payload }) };
    if (profileImage) {
      dataToSend.user_image = profileImage;
    }
    if (aadhar) {
      dataToSend.aadhaar_image = aadhar;
    }
    if (pan) {
      dataToSend.pan_image = pan;
    }
    let response = await postFormDataCall("/profile_update", {}, dataToSend);

    if (response?.success && response?.data) {
      getProfile();
    }
  };

  const getPincodes = async () => {
    let response = await getCall("/get_pincode_data", {});

    if (response?.success && response?.data) {
      setPincodeOption(response?.data);
      return response?.data;
    }
    return [];
  };

  const getServices = async () => {
    const payload = {};
    let dataToSend = { data: getPayloadHash({ data: payload }) };

    let response = await postFormDataCall("/service-for-user", {}, dataToSend);
    if (response?.success && response?.data) {
      setServiceOption(response?.data);
      return response?.data;
    }
    return [];
  };

  const getProfile = async () => {
    setIsLoading(true);

    const token = getLocalToken();
    let userInfo = decryptor({ encryptedData: token });
    if (!userInfo) return null;

    userInfo = JSON.parse(userInfo);

    const payload = {
      user_id: userInfo?.user_id,
    };
    let dataToSend = { data: getPayloadHash({ data: payload }) };

    let response = await postFormDataCall("/profile", {}, dataToSend);

    if (response?.success && response?.JOBS_APP) {
      setData({
        name: response?.JOBS_APP?.name || "",
        email: response?.JOBS_APP?.email || "",
        phone: response?.JOBS_APP?.phone || "",
        dob: response?.JOBS_APP?.date_of_birth
          ? convertDateOrder(
              response?.JOBS_APP?.date_of_birth,
              ["m", "d", "y"],
              ["y", "m", "d"]
            )
          : "",
        gender: await getCurrentGender(response?.JOBS_APP?.gender || ""),
        pincode: await getCurrentPincode(response?.JOBS_APP?.pincode || ""),
        service: await getCurrentService(response?.JOBS_APP?.services || ""),
        city: response?.JOBS_APP?.city || "",
        profileImage: response?.JOBS_APP?.user_image || "",
        aadhaar: response?.JOBS_APP?.aadhaar || "",
        pan: response?.JOBS_APP?.pan || "",
      });
      await getServices();
    }
    setProfileImage(null);
    setIsLoading(false);
  };

  useEffect(() => {
    getProfile();
  }, []);

  return (
    <>
      <h1 className="text-3xl font-semibold sticky top-0 bg-white z-40 py-3 border-b border-gray-300">
        Profile
      </h1>
      {isLoading ? (
        <SkeletonProfile />
      ) : (
        <>
          <div className="flex justify-center w-full lg:w-[600px] mx-auto mt-8">
            <label
              htmlFor="profile-image"
              className="relative cursor-pointer p-0.5 border-2 border-black rounded-full after:content-['Upload'] after:text-white after:tracking-wide after:hidden after:items-center after:justify-center after:size-full after:bg-[rgba(0,0,0,0.3)] after:absolute after:bottom-0 after:left-0 after:rounded-full hover:after:flex size-32"
            >
              {(profileImage || data.profileImage) && (
                <button
                  type="button"
                  className="absolute -right-1 -top-1 bg-red-600 text-white rounded-full p-0.5"
                  onClick={(e) => {
                    e.preventDefault();
                    setData((prev) => ({ ...prev, profileImage: "" }));
                    setProfileImage(null);
                  }}
                >
                  <IoMdClose />
                </button>
              )}
              {data?.profileImage && (
                <img
                  className="size-full rounded-full mx-auto"
                  src={data?.profileImage || ""}
                  alt={data?.name || ""}
                />
              )}
              {profileImage && (
                <img
                  className="size-full rounded-full mx-auto"
                  src={URL.createObjectURL(profileImage)}
                  alt={data?.name || ""}
                />
              )}
              <input
                type="file"
                id="profile-image"
                className="hidden"
                onInput={(e) => imageHandler(e)}
              />
            </label>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5 mt-6 w-full lg:w-[600px] mx-auto">
            <Input
              type="text"
              label="Name"
              value={data.name}
              setValue={(val) => {
                setData((prev) => ({ ...prev, name: val }));
              }}
            />
            <Input
              type="email"
              label="Email"
              value={data.email}
              setValue={(val) => {
                setData((prev) => ({ ...prev, email: val }));
              }}
            />
            <Input
              type="text"
              label="Phone Number"
              value={data.phone}
              setValue={(val) => {
                setData((prev) => ({ ...prev, phone: val }));
              }}
            />
            <Input
              type="date"
              label="Date of birth"
              value={data.dob}
              setValue={(val) => {
                setData((prev) => ({ ...prev, dob: val }));
              }}
            />
            <DropdownSearch
              label="Gender"
              value={data.gender}
              option={genderOption}
              show="label"
              val="value"
              setValue={(val) => {
                setData((prev) => ({ ...prev, gender: val }));
              }}
            />
            <DropdownSearch
              label="Pincode"
              value={data.pincode}
              option={pincodeOption}
              show="pincode"
              val="id"
              setValue={(val) => {
                setData((prev) => ({ ...prev, pincode: val }));
              }}
            />
          </div>

          <div className="mt-5 w-full lg:w-[600px] mx-auto flex flex-col gap-5">
            <div className="w-full">
              <DropdownSearch
                label="Service"
                value={data.service}
                option={serviceOption}
                show="subcategory_name"
                val="id"
                setValue={(val) => {
                  setData((prev) => ({ ...prev, service: val }));
                }}
              />
            </div>

            {data.service?.service_type === "Commercial" && (
              <Fragment>
                <h6 className="text-lg font-semibold mt-2 -mb-3">
                  Company Details
                </h6>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5 w-full">
                  <Input
                    type="text"
                    label="GST"
                    value={data.gst}
                    setValue={(val) => {
                      setData((prev) => ({ ...prev, gst: val }));
                    }}
                  />
                  <Input
                    type="email"
                    label="Company Email"
                    value={data.company_email}
                    setValue={(val) => {
                      setData((prev) => ({ ...prev, company_email: val }));
                    }}
                  />
                  <Input
                    type="text"
                    label="Bank Name"
                    value={data.bank_name}
                    setValue={(val) => {
                      setData((prev) => ({ ...prev, bank_name: val }));
                    }}
                  />
                  <Input
                    type="number"
                    label="Account Number"
                    value={data.account_number}
                    setValue={(val) => {
                      setData((prev) => ({ ...prev, account_number: val }));
                    }}
                  />
                  <Input
                    type="text"
                    label="IFSC Code"
                    value={data.ifsc_code}
                    setValue={(val) => {
                      setData((prev) => ({ ...prev, ifsc_code: val }));
                    }}
                  />
                  <Input
                    type="text"
                    label="Branch Name"
                    value={data.branch_name}
                    setValue={(val) => {
                      setData((prev) => ({ ...prev, branch_name: val }));
                    }}
                  />
                </div>
              </Fragment>
            )}
            {/* <div className="h-32 w-full">
              <FileInput
                label="Aadhar"
                file={
                  aadhar ? aadhar : data?.aadharFile ? data?.aadharFile : ""
                }
                onInput={aadharHandler}
                id={generateRandomString(7)}
                onRemove={() => {
                  setAadhar(null);
                  setData((prev) => ({ ...prev, aadharFile: "" }));
                }}
              />
            </div>

            <div className="h-32 w-full">
              <FileInput
                label="PAN"
                file={pan ? pan : data?.panFile ? data?.panFile : ""}
                onInput={panHandler}
                id={generateRandomString(7)}
                onRemove={() => {
                  setPan(null);
                  setData((prev) => ({ ...prev, panFile: "" }));
                }}
              />
            </div> */}

            <button
              type="button"
              className="w-20 min-h-10 rounded-lg bg-blue-500 text-white ml-auto hover:scale-105 transition-all duration-150"
              onClick={() => setConfirmOpen(true)}
            >
              Save
            </button>
          </div>
        </>
      )}
      <PopupWrapper open={confirmOpen}>
        <div className="w-full sm:w-1/2 lg:w-1/3 h-1/4 rounded-lg bg-white flex flex-col justify-between p-5 shadow-2xl shadow-gray-800">
          <div className="flex">
            <div className="flex flex-col gap-1">
              <h6 className="text-xl font-bold text-gray-900">
                Update Profile
              </h6>
              <p className="text-gray-700">
                Are you sure you want to update your profile ?
              </p>
            </div>
          </div>

          <div className="w-full flex items-center justify-end gap-2">
            <button
              type="button"
              className="w-20 py-1.5 rounded-lg bg-blue-50 text-blue-500 border border-blue-500 hover:scale-105 transition-all duration-150"
              onClick={() => setConfirmOpen(false)}
            >
              Close
            </button>
            <button
              type="button"
              className="w-24 py-1.5 rounded-lg bg-blue-500 text-white border border-blue-500 hover:scale-105 transition-all duration-150"
              onClick={() => {
                updateProfile();
                setConfirmOpen(false);
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      </PopupWrapper>
    </>
  );
};

export default CompanyProfile;
